export default __webpack_public_path__ + "static/media/E_SDG_logo_without_UN_emblem_Square_Transparent_WEB.3687942d.png";